import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Come Leggere le QC Photos Itaobuy: Guida al Controllo Qualità',
  url: `${siteUrl}/itaobuy-qc-photos`,
  description: 'Impara a valutare la qualità dei prodotti itaobuy attraverso le foto QC: controlla cuciture, materiali, logo e dettagli.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function QCPhotosPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ QUALITÀ</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Come Leggere le QC Photos Itaobuy: Guida al Controllo Qualità
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Impara a valutare la <strong className="text-background-50">qualità dei prodotti itaobuy</strong> attraverso le foto QC: controlla cuciture, materiali, logo e dettagli.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per il database completo con foto QC.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Cosa Sono le QC Photos</h2>
              <p className="mb-4">Le <strong className="text-foreground-950">foto QC (Quality Check) su itaobuy</strong> sono immagini dettagliate del prodotto reale scattate prima della spedizione. Servono a verificare che l'articolo corrisponda alla descrizione e alle aspettative. È uno degli strumenti più importanti per fare acquisti sicuri.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Cosa Controllare nelle Foto QC</h2>
              <ul className="space-y-2 list-disc pl-5 mb-4">
                <li><strong className="text-foreground-950">Cuciture e Finiture</strong>: Verifica che siano pulite, dritte e senza fili tirati</li>
                <li><strong className="text-foreground-950">Materiali e Colori</strong>: Confronta con le foto del venditore, controlla che i colori siano fedeli</li>
                <li><strong className="text-foreground-950">Logo e Dettagli</strong>: Assicurati che il logo sia posizionato correttamente e senza difetti</li>
                <li><strong className="text-foreground-950">Etichette e Tag</strong>: Verifica la presenza di etichette interne e cartellini</li>
              </ul>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Quando Rifiutare un Prodotto</h2>
              <p className="mb-4">Se le <strong className="text-foreground-950">foto QC mostrano difetti evidenti</strong>, colori diversi dalla descrizione o qualità inferiore alle aspettative, hai il diritto di rifiutare il prodotto e chiedere un rimborso o una sostituzione. Per maggiori informazioni sulla sicurezza, leggi la <Link to="/itaobuy-e-sicuro" className="text-primary-600 font-medium hover:underline">guida alla sicurezza</Link>.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Verifica la Qualità</h3>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">QC photos itaobuy</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}